import type { PropsWithChildren } from 'react';
import React from 'react';

import styles from './styles.module.scss';

const MessageView: React.FC<PropsWithChildren> = ({ children }) => {
    return <p className={styles.root}>{children}</p>;
};

export default MessageView;
